/**
 * Process HTML content to style mention spans.
 * Adds Nord-themed frost-blue pill styling to <span data-type="mention">.
 * Also converts raw @<uuid> in plain text to styled mentions.
 */
export function processMentions(
  html: string,
  senderNames: Record<string, string>,
  currentUserId?: string,
): string {
  // 1. Style existing Tiptap mention spans:
  //    <span data-type="mention" data-id="uuid" class="mention">@Name</span>
  let result = html.replace(
    /<span[^>]*data-type="mention"[^>]*data-id="([^"]*)"[^>]*>@?([^<]*)<\/span>/gi,
    (_match, userId: string, displayText: string) => {
      const name = displayText || senderNames[userId] || userId.slice(0, 8);
      const isMe = userId === currentUserId;
      const cls = isMe
        ? 'mention-pill mention-pill--me'
        : 'mention-pill';
      return `<span class="${cls}" data-user-id="${userId}">@${name}</span>`;
    },
  );

  // 2. Convert raw @<uuid> patterns in plain text (backend regex format)
  const uuidPattern = /@([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gi;
  result = result.replace(uuidPattern, (_match, userId: string) => {
    const name = senderNames[userId] || userId.slice(0, 8);
    const isMe = userId === currentUserId;
    const cls = isMe
      ? 'mention-pill mention-pill--me'
      : 'mention-pill';
    return `<span class="${cls}" data-user-id="${userId}">@${name}</span>`;
  });

  return result;
}
